import UPTab from 'components/tab';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_MANAGERS, API_USERS, SUPERADMINS } from 'translations/constants';
import SuperAdmins from './SuperAdmins';
import ApiUsers from './ApiUsers';
import AccountManagers from './AccountManagers';

const Users = (): JSX.Element => {
  const [t] = useTranslation();

  const tabs = [
    { title: t(SUPERADMINS), route: 'superadmins' },
    { title: t(API_USERS), route: 'apiusers' },
    { title: t(ACCOUNT_MANAGERS), route: 'accountmanagers' },
  ];

  return (
    <UPTab sections={tabs}>
      <SuperAdmins />
      <ApiUsers />
      <AccountManagers />
    </UPTab>
  );
};

export default Users;
